import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { financingTypeOptions } from '@/module/Nomen/FinancingType/model/FinancingTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type FinancingTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function FinancingTypeSelectControl<T extends FieldValues>(props: FinancingTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(financingTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
